interface NavigationItem {
  Column1?: unknown[]
  Column2?: unknown[]
  Column3?: unknown[]
  ShowSubNavigation?: boolean
  Link?: string
  [key: string]: unknown
}

export function useNavigation() {
  const open = useState('navigationOpen', () => false)
  const showSubmenu = useState<number | null>('showSubmenu', () => null)

  let delay: ReturnType<typeof setTimeout> | null = null
  const { breakpoint } = useApp()

  const hasDrawer = computed(() => {
    return ['mobile', 'phablet', 'tablet', 'desktop'].includes(breakpoint.value)
  })

  function openNavigation() {
    open.value = true
  }

  function closeNavigation() {
    open.value = false
    showSubmenu.value = null
  }

  function toggleNavigation() {
    if (open.value) {
      closeNavigation()
    }
    else {
      openNavigation()
    }
  }

  function hasSubitems(item: NavigationItem) {
    return (item?.Column1?.length || item?.Column2?.length || item?.Column3?.length) && item?.ShowSubNavigation
  }

  function mouseOver(item: NavigationItem, index: number) {
    if (hasSubitems(item) && !hasDrawer.value) {
      if (delay) {
        clearTimeout(delay)
        delay = null
      }

      delay = setTimeout(() => {
        showSubmenu.value = index
      }, 200)
    }
  }

  function mouseOut() {
    if (!hasDrawer.value) {
      if (delay) {
        clearTimeout(delay)
        delay = null
      }

      showSubmenu.value = null
    }
  }

  function keypress(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      closeNavigation()
    }
  }

  function openSubnavigation(index: number) {
    showSubmenu.value = index
  }

  function closeSubnavigation(index: number) {
    if (showSubmenu.value === index) {
      showSubmenu.value = null
    }
  }

  function toggleSubnavigation(index: number) {
    if (showSubmenu.value === index) {
      closeSubnavigation(index)
    }
    else {
      openSubnavigation(index)
    }
  }

  return {
    open,
    showSubmenu,
    hasDrawer,
    openNavigation,
    closeNavigation,
    toggleNavigation,
    hasSubitems,
    mouseOver,
    mouseOut,
    keypress,
    openSubnavigation,
    closeSubnavigation,
    toggleSubnavigation,
  }
}
